/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvitationRow__OrganisationMembershipInvitationFragment = { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus, invitationToken: string, author: { __typename: 'User', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, organisation: { __typename: 'OrganisationMembershipInvitationOrganisation', id: string } };

export type InvitationRow__ReceivedLinkingInvitationFragment = { __typename: 'ReceivedLinkingInvitation', id: string, title: string, token: string, publicProfileSlug?: string | null, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export type InvitationListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvitationListQuery = { viewer?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, receivedLinkingInvitations: Array<{ __typename: 'ReceivedLinkingInvitation', id: string, title: string, token: string, publicProfileSlug?: string | null, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } } | null };

export const InvitationRow__OrganisationMembershipInvitationFragmentDoc = gql`
    fragment InvitationRow__OrganisationMembershipInvitation on OrganisationMembershipInvitation {
  id
  status
  invitationToken
  author {
    id
    title
    description
    website
    isMeister
    familyname
    firstname
    fullname
    locale
    email
    phones {
      id
      main
      type
      number
    }
    avatar {
      ...AttachmentSnapshot
    }
  }
  organisation {
    id
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const InvitationRow__ReceivedLinkingInvitationFragmentDoc = gql`
    fragment InvitationRow__ReceivedLinkingInvitation on ReceivedLinkingInvitation {
  id
  title
  token
  publicProfileSlug
  logo {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const InvitationListDocument = gql`
    query InvitationList {
  viewer {
    ... on Viewer {
      id
      organisation {
        id
        receivedLinkingInvitations {
          ...InvitationRow__ReceivedLinkingInvitation
        }
      }
    }
  }
}
    ${InvitationRow__ReceivedLinkingInvitationFragmentDoc}`;

/**
 * __useInvitationListQuery__
 *
 * To run a query within a React component, call `useInvitationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationListQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvitationListQuery(baseOptions?: Apollo.QueryHookOptions<InvitationListQuery, InvitationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationListQuery, InvitationListQueryVariables>(InvitationListDocument, options);
      }
export function useInvitationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationListQuery, InvitationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationListQuery, InvitationListQueryVariables>(InvitationListDocument, options);
        }
export function useInvitationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationListQuery, InvitationListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationListQuery, InvitationListQueryVariables>(InvitationListDocument, options);
        }
export type InvitationListQueryHookResult = ReturnType<typeof useInvitationListQuery>;
export type InvitationListLazyQueryHookResult = ReturnType<typeof useInvitationListLazyQuery>;
export type InvitationListSuspenseQueryHookResult = ReturnType<typeof useInvitationListSuspenseQuery>;
export type InvitationListQueryResult = Apollo.QueryResult<InvitationListQuery, InvitationListQueryVariables>;